// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_product,
  add_product,
  update_product,
  delete_product,
  get_product_list
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const initialState = {
  products: [],
  productlist: [],
  productfilterlist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  ptotalPages: 0,
  ppageSize: 10,
  pcount: 0,
  pactivePage: 1,
  ploading: false,
  perror:null,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    product_name :"",
    category :"",
    price :"",
    mrp :"",
    main_image :"",
    description :"",
    brand :"",
  },
};
// Async Thunks for API Calls
export const fetchproductList = createAsyncThunk(
  "product/fetchproductList",
  async ({page,page_size,search,sort,category,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_product_list(page,page_size,search,sort,category,school_id, token, signal);
        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);




// Async Thunks for API Calls
export const fetchproduct = createAsyncThunk(
  "product/fetchproduct",
  async ({ page, page_size,school_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_product(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createproduct = createAsyncThunk(
  "product/createproduct",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_product(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateproduct = createAsyncThunk(
  "product/updateproduct",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_product(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteproduct = createAsyncThunk(
  "product/deleteproduct",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_product({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    setpActivePage(state, action) {
      state.pactivePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
        reduxState.formData = { ...action.payload };
      },
    resetFormData(state) {
      state.formData = {
        product_name :"",
        category :"",
        price :"",
        mrp :"",
        main_image :"",
        description :"",
        brand :"",
       
      };
    },
    setproduct(state, action) {
      state.products = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setpPageSize(state, action) {
      state.ppageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // User list
      .addCase(fetchproductList.pending, (state) => {
        state.ploading = true;
      })
      .addCase(fetchproductList.fulfilled, (state, action) => {
        state.ploading = false;
        console.log("=====",action.payload.results)
        state.productlist = action.payload.results;
        // console.log(state.productlist)
        state.pcount = action.payload.count;
        state.ptotalPages = Math.ceil(action.payload.count / state.ppageSize);
      })
      .addCase(fetchproductList.rejected, (state, action) => {
        state.ploading = false;
        state.perror = action.payload;

      })
      // Fetch Classes
      .addCase(fetchproduct.pending, (state) => {
        state.loading = true;
      })


      .addCase(fetchproduct.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchproduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createproduct.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createproduct.fulfilled, (state, action) => {
        state.addLoading = false;
        state.products = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createproduct.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateproduct.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateproduct.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateproduct.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteproduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteproduct.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteproduct.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setproduct,
  setActivePage,
  setpActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize,
  setpPageSize,
  setSchoolId,
} = productSlice.actions;
export default productSlice.reducer;
